import { API } from '../api'
import { RemoveParams, RemoveResponse } from './interface'

export const remove = async (
  params: RemoveParams
): Promise<{
  conteudo: string
  sucesso: boolean
}> => {
  try {
    const response = await API.patch<RemoveResponse>(
      '/logistica/item',
      params
    )

    return {
      conteudo: response?.content,
      sucesso: response?.isSuccess
    }
  } catch (error) {
    console.error('Erro ao remover itens:', error)
    return {
      conteudo: null,
      sucesso: false
    }
  }
}
